import type { Navigation } from '@angular/router';

import { CLARITY_EMAIL_MARK_READ_NAVIGATION_STATE } from './constants/clarity-email-mark-read-navigation-state.constant';

const IMPERATIVE_TRIGGER: Navigation['trigger'] = 'imperative';

/**
 * Whether a navigation is an in-app open that carries {@link CLARITY_EMAIL_MARK_READ_NAVIGATION_STATE}.
 *
 * @returns `false` for no navigation, for the app's first navigation (a pasted link or a reload) and
 * for a Back/Forward sync, even when the restored history entry still holds the state.
 */
export function isClarityEmailMarkReadNavigation(navigation: Navigation | null): boolean {
	if (navigation?.trigger !== IMPERATIVE_TRIGGER || navigation.previousNavigation === null) {
		return false;
	}

	const state = navigation.extras.state;

	return Object.entries(CLARITY_EMAIL_MARK_READ_NAVIGATION_STATE).every(([key, value]) => state?.[key] === value);
}
